import _ from 'underscore';

const CAMPAIGN_PAGE_SIZE = 10;

function transformCampaignData(data, optionalCampaignSelect = []) {
  if (!_.isArray(data)) {
    return [];
  }

  const campaignData = data.map(item => (_.extend(
    _.pick(item, 'Id', 'Name', 'Status', 'CampaignType', 'CampaignSubType', ...optionalCampaignSelect),
    {
      name: item.Name,
      status: item.Status,
      CampaignSettings: item.CampaignSettings,
    }
  )));

  return {
    totalCount: data.totalCount,
    items: campaignData,
  };
}

export function getCampaignData({
  query = '',
  pageNumber = 0,
  pageSize = CAMPAIGN_PAGE_SIZE,
  optionalCampaignFilter = '',
  optionalCampaignSelect = [],
}, jsdata) {
  const signleQuoteTerminatedQuery = query.replace('\'', '\'\'');

  const filter = _.compact([
    optionalCampaignFilter,
    query && `contains(Name, '${signleQuoteTerminatedQuery}')`,
    '(CampaignType ne Enum.CampaignType\'Smart\')',
  ]).join(' and ');

  const $select = [
    'Id',
    'Name',
    'Status',
    'CampaignType',
    'CampaignSubType',
    'CampaignSettings',
  ].concat(optionalCampaignSelect).join(', ');

  const formatQuery = {
    $select,
    $skip: pageNumber * pageSize,
    $top: pageSize,
    $orderby: 'Name asc',
  };

  if (filter) {
    formatQuery.$filter = filter;
  }

  return jsdata.Campaign.findAll({
    query: formatQuery,
  }).then(data => transformCampaignData(data, optionalCampaignSelect));
}
